import { AutocompleteControl } from './autocomplete-control';

import { AutocompleteOptionInterface } from '../components/autocomplete';
import { CountryAutocompleteControlInterface, CountryAutocompleteItemInterface } from '../components/country-autocomplete/interfaces';

export class CountryAutocompleteControl extends AutocompleteControl {
  public countries: CountryAutocompleteItemInterface[];

  constructor(data: CountryAutocompleteControlInterface) {
    super(data);

    const { countries } = data;

    this.countries = countries;
  }

  setOptions(options: AutocompleteOptionInterface[]): void {
    this.options = options;
  }
}
